(function (angular, _, $, viewport, Cookies, window) {
    'use strict';

    window.THF.Angular.LiveQuoteTool.controller('LiveQuoteTool', ['$scope', 'ngDialog', '$timeout', 'ServiceModel', 'ProductsModel', 'CalculateModel', function ($scope, ngDialog, $timeout, SM, PM, CalculateModel) {

        /**
         * Turn on testing mode which disables the API and returns one of two hard coded quotes.
         * @type {boolean}
         */
        var testing = false;
        /**
         * Used to fix issues in mobile and resize events that are caused when resizing is happening.
         */
        var originalWidth = $(window).width();

        window.lqtScope = $scope;
        /**
         * Timeout Variables that hold the timeout references so we can cancel when the watchers change.
         */
        var toModel = null;

        var modal = new THF.Interface.Modal();

        /**
         * This model is for the main data to be saved for the live quote, this is the information
         * to be passed across to the various cookies and other linked tools, e.g. join form.
         */
        $scope.model = {
            hospitalType: false,
            extrasType: false,
            state: '',
            age: '29',
            coverType: '',
            income: '0',
            extended: false,
            asAtDateApril: false
        };

        /*
        Global Siteconfig; name, phone number etc
        Passed via liveQuoteToolPageData in /Views/LiveQuoteTool.cshtml
         */
        $scope.siteConfig = {
            siteName: liveQuoteToolPageData.siteName,
            contactNumber: liveQuoteToolPageData.contactNumber
        };

        /**
         * The start page displays the semantic statement module with a hero feature image.
         * The quote page displays the live quote tool.
         *
         * The start page will display if the correct query parameters are not passed
         * through to the live quote tool.
         *
         * @type {{start: boolean, quote: boolean}}
         */
        $scope.page = {
            start: false,
            quote: false,
            form: false,
            hasFormContent: contactFormData,
            copy: {
                coverTitle: liveQuoteToolPageData.coverSummaryTitle,
                coverSummaryTitle: liveQuoteToolPageData.coverSummaryTitle,
                coverHospitalTitle: liveQuoteToolPageData.coverHospitalTitle,
                coverExtrasTitle: liveQuoteToolPageData.coverExtrasTitle
            }
        };

        /**
         * All values related to the quote panel are shown in here as well as the various states for
         * showing or hiding of various panels and message display.
         *
         * @type {
         *     {
         *         text: {hospitalCover: string, extrasCover: string},
         *         value: {excess: number, rebatePercent: number, lhcPercent: number, price: number, frequency: string},
         *         show: {
         *              coverDetails: boolean, coverDetailsCheckboxes: boolean, checkboxExtended: boolean, checkboxAprilPriceChanges: boolean, rebateDisclaimer: boolean, lhcDisclaimer: boolean, aprilDisclaimer: boolean},
         *         dropdowns: {state: *[], frequency: *[], income: Array}
         *     }
         * }
         */

        $scope.quotePanel = {
            text: {
                hospitalCover: '',
                hospitalTier: '',
                extrasCover: '',
                frequency: '',
            },
            buttons: {
                viewCoverDetails: {
                    active: 'Refine Quote',
                    closed: 'Refine Quote',
                    open: 'Hide'
                }
            },
            disabled: {
                checkboxExtended: false
            },
            value: {
                excess: false,
                rebatePercent: 0,
                lhcPercent: 0,
                price: 0,
                frequency: 'Weekly'
            },
            show: {
                loading: false,
                coverDetails: false,
                coverDetailsCheckboxes: false,   // Show the checkbox for the cover details.
                checkboxExtended: false,
                checkboxAprilPriceChanges: (liveQuoteToolPageData.checkboxAprilPriceChanges === 'checked'),        // Show the april price changes checkbox
                rebateDisclaimer: false,
                // TODO - Double check if loading will not trigger unless we turn off continuous cover, which is not an option in the live quote tool.
                lhcDisclaimer: false,            //
                aprilDisclaimer: (liveQuoteToolPageData.aprilDisclaimer === 'checked'), // Shows the april messaging in the footer of the quotePanel.
            },
            dropdowns: {
                age: liveQuoteToolPageData.age,
                state: liveQuoteToolPageData.state,
                coverTypes: liveQuoteToolPageData.coverTypes,
                frequency: liveQuoteToolPageData.frequency,
                excess: [],
                /**
                 * This maps directly to the rebate tiers from the government pricing tables.
                 */
                income: []
            }
        };

        isMQMActive();
        function isMQMActive(){
            if($scope.page.hasFormContent){
                DSTAPI.track('event', {
                    category: 'Contact Form Module',
                    action: 'MQM active',
                    label: 'MQM'
                });
            }
            else{
                DSTAPI.track('event', {
                    category: 'Contact Form Module',
                    action: 'MQM inactive',
                    label: 'MQM'
                });
            }
        }

        function showErrorModal(message) {
            debugLog('showErrorModal()');
            ngDialog.open({
                template: 'modal-general-error',
                className: 'ngdialog-theme-plain general-error',
                controller: ['$scope', function ($scope) {
                    $scope.errorMessage = message;
                        $scope.onClose = function($event) {
                        $event.preventDefault();
                        $scope.closeThisDialog();
                    };
                }],
                scope: $scope
            });
        }
        
        $scope.actionPrint = function ($event) {
            debugLog('actionPrint()');
            window.print();
            $event.preventDefault();

            DSTAPI.track('event', {
                category: 'Live Quote Tool Results Page Intent',
                action: 'Intent Measure',
                label: 'Print'
            });
        };

        function showSendEmailSuccessModal() {
            ngDialog.open({
                template: 'modal-email-success',
                className: 'ngdialog-theme-plain email-success',
                controller: ['$scope', function ($scope) {
                    $scope.onClose = function ($event) {
                        $event.preventDefault();
                        $scope.closeThisDialog();
                    };
                }],
                scope: $scope
            });

            DSTAPI.track('page', {
                url: '/live-quote-tool/email-pop-up/completed'
            });
        }

        function getDropdownLabel(dropdown, value) {
            debugLog('getDropdownLabel()');
            var values = _.filter(dropdown, { value: value });
            if (typeof values[0] !== 'undefined' && typeof values[0].label !== 'undefined') {
                return values[0].label;
            }
            return '';
        };

        $scope.dropdownValueChanged = function (dropdown, value) {
            var eventLabel = '';
            var eventActions = {
                'state': 'State',
                'income': 'Income',
                'age': 'Age',
                'coverTypes': 'Membership Type',
            }

            var data = $scope.quotePanel.dropdowns[dropdown];
            $.each(data, function (index) {
                if (data[index].value === value) {
                    eventLabel = data[index].label;
                    return false;
                }
            });

            DSTAPI.track('event', {
                category: 'Live Quote Tool Adjustment',
                action: eventActions[dropdown],
                label: eventLabel
            });
        }

        $scope.updateCoverTypeDisplayValue = function () {
            debugLog('$scope.updateCoverTypeDisplayValue()');
            $scope.quotePanel.value.coverType = getDropdownLabel($scope.quotePanel.dropdowns.coverTypes, $scope.model.coverType);
        };

        /**
         * This is for the tab buttons that are displayed.
         * @type {{hospital: *}}
         */
        $scope.tabs = {
            hospital: {
                loading: false,
                buttonText: {
                    active: 'Change',
                    open: 'Done',
                    close: 'Change'
                },
                buttonIcon: {
                    active: window.THF.SiteSettings.svgSprite + '#ui-compare',
                    open: window.THF.SiteSettings.svgSprite + '#ui-legend-covered',
                    close: window.THF.SiteSettings.svgSprite + '#ui-compare',
                },
                mobileButtonText: 'CHANGE OR COMPARE COVER'
            },
            extras: {
                loading: false,
                buttonText: {
                    active: 'Change',
                    open: 'Done',
                    close: 'Change'
                },
                buttonIcon: {
                    active: window.THF.SiteSettings.svgSprite + '#ui-compare',
                    open: window.THF.SiteSettings.svgSprite + '#ui-legend-covered',
                    close: window.THF.SiteSettings.svgSprite + '#ui-compare',
                },
                mobileButtonText: 'CHANGE OR COMPARE COVER'
            }
        };

        $scope.summaryPanel = {
            show: true,
            hospital: {
                show: true,
                accordionCollapsed: false
            },
            extras: {
                show: false
            }
        };

        $scope.hospitalPanel = {
            show: false
        };

        $scope.extrasPanel = {
            show: false
        };

        $scope.panels = {
            tab: {
                hospital: {
                    loading: false
                },
                extras: {
                    loading: false
                }
            }
        };


        /**
         * Various service data models that are used to store the relevant data for
         * the information shown in the compare tables.
         */
        $scope.selectedProduct = {
            hospital: {},
            extras: {}
        };
        $scope.serviceTypes = {
            hospital: {},
            extras: {}
        };
        $scope.products = {
            hospital: [],
            extras: [],
            slideWidth: 64
        };
        $scope.quoteData = [];

        $scope.coverText = function (coverType) {
            if (coverType === 'Y') {
                return 'Covered';
            }
            else if (coverType === 'N') {
                return 'Not Covered';
            }
            else if (coverType === 'NA') {
                return 'Not Applicable';
            }
            else if (coverType === 'P') {
                return 'Partially Covered';
            }
            else if (coverType === 'OF') {
                return 'Other Features';
            }
            else if (coverType === 'CS') {
                return 'Covered by State Government';
            }
            else if (coverType === 'R') {
                return 'Restricted';
            }
            return '';
        };

        /**
         * This is the data needed to populate the dropdown for the income which changes when you
         * change the cover types between single, single parent, family and couples.
         *
         * @type {{singles: *[], families: *[]}}
         */
        $scope.rebateTierIncomeGroups = {
            singles: liveQuoteToolPageData.incomeSingle,
            families: liveQuoteToolPageData.incomeFamily
        };

        function showHideCheckboxes() {
            debugLog('showHideCheckboxes()');
            if ($scope.quotePanel.show.checkboxExtended || $scope.quotePanel.show.checkboxAprilPriceChanges) {
                $scope.quotePanel.show.coverDetailsCheckboxes = true;
            }
            else {
                $scope.quotePanel.show.coverDetailsCheckboxes = false;
            }
        }

        function selectDisplayPage() {
            debugLog('selectDisplayPage()');
            var hrc = '';
            var age = '';
            var asAtApril = false;
            var rebateTier = '0';
            var extended = false;
            var displayForm = true;

            var cookieData = Cookies.getJSON('thf-live-quote-tool');
            if (typeof cookieData == 'object') {
                if (typeof cookieData.healthRateCode !== 'undefined' && cookieData.healthRateCode !== '') {
                    hrc = cookieData.healthRateCode;
                }

                if (typeof cookieData.age !== 'undefined' && cookieData.age !== '') {
                    age = cookieData.age;
                }

                if (typeof cookieData.asAtDateApril !== 'undefined') {
                    asAtApril = cookieData.asAtDateApril;
                }

                if (typeof cookieData.rebateTier !== 'undefined') {
                    rebateTier = cookieData.rebateTier;
                }

                if (typeof cookieData.frequency !== 'undefined') {
                    $scope.quotePanel.value.frequency = cookieData.frequency;
                }
            }
            
            var formCookie = Cookies.getJSON('contact-form-module');
            if(typeof formCookie == 'object'){
                if(typeof formCookie.displayForm !== 'undefined' && formCookie.displayForm !== ''){
                    displayForm = formCookie.displayForm;
                }
            }
            if(formCookie == undefined){
                var formSession = JSON.parse(sessionStorage.getItem('contact-form-module'));
                if(formSession != null && typeof formSession == 'object'){
                    if(typeof formSession.displayForm !== 'undefined' && formSession.displayForm !== ''){
                        displayForm = formSession.displayForm;
                    }
                }
            }

            var locationHRC = window.THF.Utility.Location.queryParam('hrc');
            var locationAge = window.THF.Utility.Location.queryParam('age');
            var locationProvideDetails = window.THF.Utility.Location.queryParam('provide-details');
            if (locationProvideDetails !== '' && locationProvideDetails.toLowerCase() === 'false') {
                displayForm = false;
            }
            if (locationHRC !== '' || locationAge !== '') {
                hrc = locationHRC;
                age = locationAge;

                var locationAsAtApril = window.THF.Utility.Location.queryParam('asAtApril');
                var locationRebateTier = window.THF.Utility.Location.queryParam('rebateTier');
                var locationExtended = window.THF.Utility.Location.queryParam('extended');
                var locationFrequency = window.THF.Utility.Location.queryParam('frequency');

                if (locationAsAtApril !== '') {
                    asAtApril = (locationAsAtApril == '1');
                }

                if (locationRebateTier !== '') {
                    rebateTier = locationRebateTier;
                }

                if (locationExtended !== '') {
                    extended = (locationExtended == '1');
                }

                if (locationFrequency !== '') {
                    $scope.quotePanel.value.frequency = locationFrequency;
                }
            }

            if (hrc === '' || age === '') {
                $scope.page.start = true;
            }
            
            else {
                // NOTE: ambulance only is not currently covered by the live quote tool as
                // the options are not available.
                
                var healthRateSelection = THF.Utility.HealthRateCode.decode(hrc);
                var membershipType = healthRateSelection.membershipType;
                if (membershipType == 'FamX') {
                    membershipType = 'Fam';
                    extended = true;
                }
                else if (membershipType == 'SPFamX') {
                    membershipType = 'SPFam';
                    extended = true;
                }

                $scope.model.state = healthRateSelection.state;
                $scope.model.coverType = membershipType;
                $scope.model.hospitalType = healthRateSelection.hospitalCover;
                $scope.model.extrasType = healthRateSelection.ancillaryCover;
                $scope.model.age = age.toString();
                $scope.model.asAtDateApril = asAtApril;
                $scope.model.income = rebateTier;
                $scope.model.extended = extended;

                debugLog(['Model: ', $scope.model]);

                if (displayForm && $scope.page.hasFormContent) {
                    $scope.page.form = true;
                }

                // TODO there is a use case here where the content will not show that will need to be fixed at some point.
                PM.byProductCode('hospital', $scope.model.hospitalType).then(function (products) {
                    $scope.selectedProduct.hospital = products[0];
                    var extrasProductCode = $scope.model.extrasType;
                    if ($scope.model.hospitalType == 'SP') {
                        extrasProductCode = 'SPAnc';
                    }

                    PM.byProductCode('extras', extrasProductCode).then(function (extrasProducts) {
                        debugLog(['extrasProducts', extrasProducts]);
                        $scope.selectedProduct.extras = extrasProducts[0];

                        $scope.page.quote = true;
                        $scope.page.start = false;
                        
                        if(!cookieData && $scope.page.hasFormContent == false){
                            DSTAPI.track('event', {
                                category: 'Live Quote Tool',
                                action: 'Quote Displayed',
                                label: 'Final Page (MQM Inactive)'
                            })
                        }
                        // $scope.selectedProduct = {
                        //     hospital: products[0],
                        //     extras: extrasProducts[0]
                        // };

                        starterPakNonStudentDependantRules();

                        debugLog(['selectedProduct: ', $scope.selectedProduct]);
                    });
                });
            }

            // TODO Figure out a better way of doing this
            // TODO as this should NOT be in the controller
            // TODO at least not in this form.
            $('.live-quote-tool').css({ visibility: 'visible' });
        }

        function starterPakNonStudentDependantRules() {
            debugLog('starterPakNonStudentDependantRules');

            $scope.quotePanel.disabled.checkboxExtended = ($scope.selectedProduct.hospital.defaultProductCode == 'SP');

            // Hide and show starterpak products.
            var hospitalStarterPak = getProductByCodeByReference('hospital', 'SP');
            var extrasStarterPak = getProductByCodeByReference('extras', 'SPAnc');

            // Hide or show the start pak options.
            if (typeof hospitalStarterPak !== 'undefined' && typeof hospitalStarterPak.display !== 'undefined') {
                hospitalStarterPak.display = (!$scope.model.extended);
            }

            if (typeof extrasStarterPak !== 'undefined' && typeof extrasStarterPak.display !== 'undefined') {
                extrasStarterPak.display = (!$scope.model.extended);
            }

        }

        function getProductByCodeByReference(type, productCode) {
            var products = [];
            if (typeof $scope.products[type] !== 'undefined') {
                products = _.filter($scope.products[type], function (item) {
                    var result = true;
                    if (item.defaultProductCode == productCode) {
                        result = true;
                    }
                    else if (_.indexOf(item.productCodes, productCode) === -1) {
                        result = false;
                    }
                    return result;
                });
            }
            return (products.length >= 1) ? products[0] : undefined;
        }

        /**
         * Toggles the cover details section.
         */
        $scope.showCoverDetails = function ($event) {
            debugLog('$scope.showCoverDetails()');
            $event.preventDefault();
            $event.stopPropagation();

            if ($scope.quotePanel.show.coverDetails) {
                $scope.quotePanel.show.coverDetails = false;
                $scope.quotePanel.buttons.viewCoverDetails.active = $scope.quotePanel.buttons.viewCoverDetails.closed;
            }
            else {
                $scope.quotePanel.show.coverDetails = true;
                $scope.quotePanel.buttons.viewCoverDetails.active = $scope.quotePanel.buttons.viewCoverDetails.open;

                DSTAPI.track('event', {
                    category: 'Live Quote Tool Adjustment',
                    action: 'Expansion',
                    label: 'View cover Details'
                });
            }
        };

        $scope.showSummary = function ($event) {
            debugLog('$scope.showSummary()');
            $event.preventDefault();
            $event.stopPropagation();
            $scope.summaryPanel.show = true;
            $scope.hospitalPanel.show = false;
            $scope.extrasPanel.show = false;
            $scope.quotePanel.show.coverDetailsCheckboxes = true;

            $scope.page.copy.coverTitle = $scope.page.copy.coverSummaryTitle;
        };

        $scope.showHospital = function ($event) {
            debugLog('$scope.showHospital()');
            $event.preventDefault();
            $event.stopPropagation();

            var eventLabel = $scope.tabs.hospital.buttonText.active;

            if ($scope.hospitalPanel.show) {
                $scope.summaryPanel.show = true;
                $scope.hospitalPanel.show = false;
                $scope.extrasPanel.show = false;

                $scope.tabs.hospital.buttonText.active = $scope.tabs.hospital.buttonText.close;
                $scope.tabs.extras.buttonText.active = $scope.tabs.extras.buttonText.close;

                $scope.tabs.hospital.buttonIcon.active = $scope.tabs.hospital.buttonIcon.close;
                $scope.tabs.extras.buttonIcon.active = $scope.tabs.extras.buttonIcon.close;

                $scope.page.copy.coverTitle = $scope.page.copy.coverSummaryTitle;
            }
            else {
                $scope.summaryPanel.show = false;
                $scope.hospitalPanel.show = true;
                $scope.extrasPanel.show = false;

                $scope.tabs.hospital.buttonText.active = $scope.tabs.hospital.buttonText.open;
                $scope.tabs.extras.buttonText.active = $scope.tabs.extras.buttonText.close;

                $scope.tabs.hospital.buttonIcon.active = $scope.tabs.hospital.buttonIcon.open;
                $scope.tabs.extras.buttonIcon.active = $scope.tabs.extras.buttonIcon.close;

                $scope.page.copy.coverTitle = $scope.page.copy.coverHospitalTitle;
            }

            DSTAPI.track('event', {
                category: 'Live Quote Tool Results Page Interaction',
                action: 'Header Tab Click - Hospital',
                label: eventLabel
            });
        };

        $scope.showExtras = function ($event) {
            debugLog('$scope.showExtras()');
            $event.preventDefault();
            $event.stopPropagation();

            var eventLabel = $scope.tabs.extras.buttonText.active;

            if ($scope.extrasPanel.show) {
                $scope.summaryPanel.show = true;
                $scope.hospitalPanel.show = false;
                $scope.extrasPanel.show = false;

                $scope.tabs.extras.buttonText.active = $scope.tabs.extras.buttonText.close;
                $scope.tabs.hospital.buttonText.active = $scope.tabs.hospital.buttonText.close;

                $scope.tabs.extras.buttonIcon.active = $scope.tabs.extras.buttonIcon.close;
                $scope.tabs.hospital.buttonIcon.active = $scope.tabs.hospital.buttonIcon.close;

                $scope.page.copy.coverTitle = $scope.page.copy.coverSummaryTitle;
            }
            else {
                $scope.summaryPanel.show = false;
                $scope.hospitalPanel.show = false;
                $scope.extrasPanel.show = true;

                $scope.tabs.extras.buttonText.active = $scope.tabs.extras.buttonText.open;
                $scope.tabs.hospital.buttonText.active = $scope.tabs.hospital.buttonText.close;

                $scope.tabs.extras.buttonIcon.active = $scope.tabs.extras.buttonIcon.open;
                $scope.tabs.hospital.buttonIcon.active = $scope.tabs.hospital.buttonIcon.close;

                $scope.page.copy.coverTitle = $scope.page.copy.coverExtrasTitle;
            }

            DSTAPI.track('event', {
                category: 'Live Quote Tool Results Page Interaction',
                action: 'Header Tab Click - Extras',
                label: eventLabel
            });
        };

        $scope.eventSetExcess = function ($event, excess) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.setExcess(excess);
        };

        $scope.setExcess = function (excess) {
            debugLog('$scope.setExcess()');

            $scope.quotePanel.value.excess = excess;
            setHospitalType();
        };

        $scope.summaryHospital = function () {
            debugLog('$scope.summaryHospital()');
            if (viewport.is('xs')) {
                if (!$scope.summaryPanel.show) {
                    $scope.hospitalPanel.show = true;
                    $scope.extrasPanel.show = false;
                }
                else {
                    $scope.hospitalPanel.show = false;
                    $scope.extrasPanel.show = false;
                }
                $scope.summaryPanel.hospital.show = true;
                $scope.summaryPanel.extras.show = false;
            }
        };

        $scope.summaryExtras = function () {
            debugLog('$scope.summaryExtras()');
            if (viewport.is('xs')) {
                if (!$scope.summaryPanel.show) {
                    $scope.hospitalPanel.show = false;
                    $scope.extrasPanel.show = true;
                }
                else {
                    $scope.hospitalPanel.show = false;
                    $scope.extrasPanel.show = false;
                }
                $scope.summaryPanel.hospital.show = false;
                $scope.summaryPanel.extras.show = true;
            }
        };

        $scope.joinNow = function ($event) {
            $event.preventDefault();
            debugLog('Join Now');

            DSTAPI.track('event', {
                category: 'Live Quote Tool Results Page Intent',
                action: 'Intent Measure',
                label: 'Join'
            });

            THF.Utility.Location.navigateToJoinForm(
                $scope.model.state,
                $scope.model.coverType,
                $scope.model.hospitalType,
                $scope.model.extrasType
            );
        };

        $scope.$watch('quotePanel.value.frequency', function (newVal, oldVal) {
            $scope.quotePanel.text.frequency = getDropdownLabel($scope.quotePanel.dropdowns.frequency, newVal);
        });

        $scope.frequencyChanged = function (value) {
            DSTAPI.track('event', {
                category: 'Live Quote Tool Adjustment',
                action: 'Date Format',
                label: value
            });
        };
        var ctr = 1;
        $scope.$watch('selectedProduct', function (newVal, oldVal) {
            debugLog(['$scope.watch[selectedProduct]: Called ' + ctr + " times", newVal]);
            ctr++;
            if (newVal.hospital && newVal.extras && typeof newVal.hospital.defaultProductCode !== 'undefined' && typeof newVal.extras.defaultProductCode !== 'undefined') {
                debugLog(['$scope.watch[selectedProduct]:: passed condition', newVal]);
                $scope.quotePanel.text.hospitalCover = newVal.hospital.label;
                $scope.quotePanel.text.hospitalTierName = newVal.hospital.tierName;
                $scope.quotePanel.text.extrasCover = newVal.extras.label;

                $scope.quotePanel.text.frequency = getDropdownLabel($scope.quotePanel.dropdowns.frequency, $scope.quotePanel.value.frequency);

                if ($scope.quotePanel.value.excess === false) {
                    var productCodeToExcess = _.invert(newVal.hospital.excessToProductCode);
                    if (typeof productCodeToExcess[$scope.model.hospitalType] === 'string') {
                        $scope.quotePanel.value.excess = parseInt(productCodeToExcess[$scope.model.hospitalType], 10);
                    }
                    else {
                        $scope.quotePanel.value.excess = 0;
                    }
                }
                // Load the minimum excess by default when the selected product changes and there is not an excess with this value available.
                else if (_.indexOf(newVal.hospital.excess, $scope.quotePanel.value.excess) < 0) {
                    $scope.quotePanel.value.excess = (typeof newVal.hospital.excess !== 'undefined' && typeof newVal.hospital.excess[0] !== 'undefined') ? parseInt(newVal.hospital.excess[0], 10) : 0;
                }

                // Update the excess dropdown
                $scope.quotePanel.dropdowns.excess = [];
                for (var i = 0; i < newVal.hospital.excess.length; i++) {
                    $scope.quotePanel.dropdowns.excess.push({
                        'label': (newVal.hospital.excess[i] === 0) ? 'NIL' : '$' + newVal.hospital.excess[i],
                        'value': newVal.hospital.excess[i]
                    });
                }

                // Get The Corrected Product Code
                setHospitalType();
                $scope.model.extrasType = newVal.extras.defaultProductCode;

                $timeout(function () {
                    $('select').selectpicker('refresh');
                });
            }

        }, true);

        $scope.$watchGroup([
            'hospitalPanel.show',
            'extrasPanel.show'
        ], function () {
            debugLog('$scope.watchGroup[hospitalPanel.show,extrasPanel.show]');
            $timeout(function () {
                debugLog('$scope.watchGroup[hospitalPanel.show,extrasPanel.show] - $timeout');
                resizeSlideWidth();
            });
        });


        $scope.$watch('quotePanel.dropdowns', function () {
            debugLog('$scope.watch[quotePanel.dropdowns]');
            // BB: Needed to allow the dropdowns to populate correctly.
            //     This is likely something to do with the digest firing
            //     after or at the same time as the update of the selectpicker.
            $timeout(function () {
                $('select').selectpicker('refresh');
            });
        }, true);

        var previousQuoteData = {};
        $scope.$watch('model', function (newVal, oldVal) {
            $timeout.cancel(toModel);
            debugLog('$scope.watch[model]::cancelled');
            toModel = $timeout(function () {
                debugLog('$scope.watch[model]');

                // Update the income dropdown for the rebate tiers when the cover type changes.
                if ($scope.model.coverType == 'Sgl') {
                    $scope.quotePanel.dropdowns.income = $scope.rebateTierIncomeGroups.singles;
                }
                else {
                    $scope.quotePanel.dropdowns.income = $scope.rebateTierIncomeGroups.families;
                }

                // We need to show/hide and show the non-student dependant checkbox option when the cover type changes
                if ($scope.model.coverType == 'Fam' || $scope.model.coverType == 'SPFam') {
                    $scope.quotePanel.show.checkboxExtended = true;

                }
                else {
                    $scope.model.extended = 0;
                    $scope.quotePanel.show.checkboxExtended = false;
                }

                starterPakNonStudentDependantRules();


                debugLog('$scope.watch[model] - hospital(' + ($scope.model.hospitalType ? 'true' : 'false') + ') / extras(' + ($scope.model.extrasType ? 'true' : 'false') + ')');
                if ($scope.model.hospitalType !== false && $scope.model.extrasType !== false) {
                    var asAtDate = '';
                    var currentDate = new Date();
                    var currentYear = currentDate.getFullYear();
                    var currentMonth = currentDate.getMonth() + 1;
                    var currentDay = currentDate.getDate();

                    if ($scope.model.asAtDateApril) {
                        var year = currentYear;
                        if (currentMonth >= 4) {
                            year = currentYear + 1;
                        }
                        asAtDate = year + '-04-01';
                    }
                    else {
                        var month = (currentMonth < 10) ? '0' + currentMonth : currentMonth;
                        var date = (currentDay < 10) ? '0' + currentDay : currentDay;
                        asAtDate = currentYear + '-' + month + '-' + date;
                    }

                    // Swap out the cover type code to the extended version if the extended model is marked as true.
                    var coverType = getCoverType();

                    var healthRateCode = THF.Utility.HealthRateCode.encode($scope.model.state, coverType, $scope.model.hospitalType, $scope.model.extrasType);

                    var age = parseInt($scope.model.age, 10);
                    var dobYear = (currentYear - age);
                    var memberMonth = (currentMonth < 10) ? '0' + currentMonth : currentMonth;
                    // var memberDay = (currentDay < 10) ? '0' + currentDay : currentDay;
                    var memberDOB = dobYear + '-' + memberMonth + '-01';

                    var continuousCover = 0;
                    if (age >= 31) {
                        continuousCover = 1;
                    }

                    var submitData = {
                        memberDOB: memberDOB,
                        memberContinuousCover: continuousCover,
                        // partnerDOB: '',
                        // partnerContinuousCover: '',
                        rebate: 1,
                        rebateTier: $scope.model.income,
                        healthRateCode: healthRateCode,
                        asAtDate: asAtDate
                    };

                    // Check the data against the previous quote data to see if they match as we only want to get a quote if the data does not match.
                    debugLog(['$scope.watch[model] - data match', !angular.equals(previousQuoteData, submitData)]);
                    if (!angular.equals(previousQuoteData, submitData)) {
                        // Ensure that the estimate can only be run if the quote panel is not loading.
                        if(!$scope.quotePanel.show.loading) {
                            if (testing) {
                                var aQuotes = [
                                    JSON.parse('{"lifetimeHealthCoverPercentage":0,"rebateLevel":30,"rebatePercentage":27.82,"healthRates":[{"Frequency":"Fortnightly","GrossAmount":116.88,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":32.55,"SubsidyAmount":0,"NetAmount":84.35,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":84.58,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":23.55,"SubsidyAmount":0,"NetAmount":61.04},{"FundType":"Ancillary","GrossAmount":32.3,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":9,"SubsidyAmount":0,"NetAmount":23.31}]}},{"Frequency":"Monthly","GrossAmount":253.24,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":70.45,"SubsidyAmount":0,"NetAmount":182.8,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":183.26,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":50.98,"SubsidyAmount":0,"NetAmount":132.29},{"FundType":"Ancillary","GrossAmount":69.98,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":19.47,"SubsidyAmount":0,"NetAmount":50.51}]}},{"Frequency":"Quarterly","GrossAmount":759.72,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":211.35,"SubsidyAmount":0,"NetAmount":548.35,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":549.77,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":152.94,"SubsidyAmount":0,"NetAmount":396.82},{"FundType":"Ancillary","GrossAmount":209.95,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":58.41,"SubsidyAmount":0,"NetAmount":151.53}]}},{"Frequency":"6 Monthly","GrossAmount":1519.44,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":422.75,"SubsidyAmount":0,"NetAmount":1096.7,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":1099.54,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":305.91,"SubsidyAmount":0,"NetAmount":793.64},{"FundType":"Ancillary","GrossAmount":419.9,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":116.84,"SubsidyAmount":0,"NetAmount":303.06}]}},{"Frequency":"Yearly","GrossAmount":3038.88,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":845.45,"SubsidyAmount":0,"NetAmount":2193.45,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":2199.08,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":611.8,"SubsidyAmount":0,"NetAmount":1587.29},{"FundType":"Ancillary","GrossAmount":839.8,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":233.65,"SubsidyAmount":0,"NetAmount":606.16}]}},{"Frequency":"Weekly","GrossAmount":58.44,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":16.3,"SubsidyAmount":0,"NetAmount":42.15,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":42.29,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":11.79,"SubsidyAmount":0,"NetAmount":30.51},{"FundType":"Ancillary","GrossAmount":16.15,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":4.51,"SubsidyAmount":0,"NetAmount":11.64}]}}]}'),
                                    JSON.parse('{"lifetimeHealthCoverPercentage":0,"rebateLevel":30,"rebatePercentage":27.82,"healthRates":[{"Frequency":"Fortnightly","GrossAmount":88.52,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":24.65,"SubsidyAmount":0,"NetAmount":63.85,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":56.22,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":15.65,"SubsidyAmount":0,"NetAmount":40.56},{"FundType":"Ancillary","GrossAmount":32.3,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":9,"SubsidyAmount":0,"NetAmount":23.29}]}},{"Frequency":"Monthly","GrossAmount":191.79,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":53.4,"SubsidyAmount":0,"NetAmount":138.4,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":121.81,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":33.91,"SubsidyAmount":0,"NetAmount":87.91},{"FundType":"Ancillary","GrossAmount":69.98,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":19.49,"SubsidyAmount":0,"NetAmount":50.49}]}},{"Frequency":"Quarterly","GrossAmount":575.38,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":160.1,"SubsidyAmount":0,"NetAmount":415.3,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":365.43,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":101.68,"SubsidyAmount":0,"NetAmount":263.76},{"FundType":"Ancillary","GrossAmount":209.95,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":58.42,"SubsidyAmount":0,"NetAmount":151.54}]}},{"Frequency":"6 Monthly","GrossAmount":1150.76,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":320.15,"SubsidyAmount":0,"NetAmount":830.6,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":730.86,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":203.33,"SubsidyAmount":0,"NetAmount":527.52},{"FundType":"Ancillary","GrossAmount":419.9,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":116.82,"SubsidyAmount":0,"NetAmount":303.08}]}},{"Frequency":"Yearly","GrossAmount":2301.52,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":640.3,"SubsidyAmount":0,"NetAmount":1661.2,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":1461.72,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":406.66,"SubsidyAmount":0,"NetAmount":1055.05},{"FundType":"Ancillary","GrossAmount":839.8,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":233.64,"SubsidyAmount":0,"NetAmount":606.15}]}},{"Frequency":"Weekly","GrossAmount":44.26,"DiscountAmount":0,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":12.35,"SubsidyAmount":0,"NetAmount":31.9,"FundDissections":{"FundDissection":[{"FundType":"Hospital","GrossAmount":28.11,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":7.84,"SubsidyAmount":0,"NetAmount":20.26},{"FundType":"Ancillary","GrossAmount":16.15,"LifetimeHealthCoverLoadingAmount":0,"RebateAmount":4.51,"SubsidyAmount":0,"NetAmount":11.64}]}}]}')
                                ];
                                var getRandomInt = function (min, max) {
                                    return Math.floor(Math.random() * (max - min)) + min;
                                };

                                $scope.quotePanel.show.loading = true;

                                var random = getRandomInt(0, 2);
                                $scope.quoteData = aQuotes[random];

                                // Sets the cookie with all the data to be read into it.
                                setCookieData();

                                $scope.quotePanel.show.loading = false;
                                $scope.tabs.hospital.loading = false;
                                $scope.tabs.extras.loading = false;
                                previousQuoteData = submitData;
                            }
                            else {
                                $scope.quotePanel.show.loading = true;

                                if (newVal.hospitalType !== oldVal.hospitalType) {
                                    $scope.tabs.hospital.loading = true;
                                }

                                if (newVal.extrasType !== oldVal.extrasType) {
                                    $scope.tabs.extras.loading = true;
                                }

                                CalculateModel.quotes(submitData).then(function (response) {
                                    if (response.result) {
                                        previousQuoteData = submitData;

                                        $scope.quoteData = response.content;

                                        $scope.quotePanel.show.loading = false;
                                        $scope.tabs.hospital.loading = false;
                                        $scope.tabs.extras.loading = false;

                                        // Sets the cookie with all the data to be read into it.
                                        setCookieData();

                                        // Track the quote using Facebook Tracking.
                                        if (typeof fbq === 'function') {
                                            fbq('track', 'Lead');
                                        }

                                        debugLog('CalaulateQuote - Success');

                                        DSTAPI.track('page', {
                                            url: '/live-quote-tool/quote-results'
                                        });

                                        if (typeof window.adalyserTracker !== 'undefined') {
                                            window.adalyserTracker("trackEvent", "lce2", {}, true);
                                        }
                                    } else {
                                        $scope.quotePanel.show.loading = false;
                                        $scope.tabs.hospital.loading = false;
                                        $scope.tabs.extras.loading = false;

                                        debugLog('CalaulateQuote - Failure');
                                        // Removed to always show a generic message as some of the error messages
                                        // returned are not safe for human eyes.
                                        // showErrorModal(response.message);
                                        showErrorModal('We can\'t give you a quote right now. You can call us on '+$scope.siteConfig.contactNumber+' for a quote over the phone or try again later.');
                                    }
                                });
                            }    
                        }
                        
                        
                    }
                }

                showHideCheckboxes();
            });
        }, true);

        function getCoverType() {
            var coverType = $scope.model.coverType;
            if ($scope.model.extended) {
                if (coverType === 'Fam') {
                    coverType = 'FamX';
                }
                else if (coverType === 'SPFam') {
                    coverType = 'SPFamX';
                }
            }
            return coverType;
        }

        function setCookieData() {
            debugLog('setCookieData');
            var healthRateCode = THF.Utility.HealthRateCode.encode($scope.model.state, getCoverType(), $scope.model.hospitalType, $scope.model.extrasType);
            var age = parseInt($scope.model.age, 10);

            var saveTheData = true;
            saveTheData = (saveTheData && $scope.quotePanel.text.hospitalCover != '');
            saveTheData = (saveTheData && $scope.quotePanel.text.extrasCover != '');
            saveTheData = (saveTheData && healthRateCode != '');
            saveTheData = (saveTheData && age != '');

            debugLog(['setCookieData::hasHospitalCover', $scope.quotePanel.text.hospitalCover != '', $scope.quotePanel.text.hospitalCover]);
            debugLog(['setCookieData::hasExtrasCover', $scope.quotePanel.text.extrasCover != '', $scope.quotePanel.text.extrasCover]);
            debugLog(['setCookieData::hasHealthRateCode', healthRateCode != '', healthRateCode]);
            debugLog(['setCookieData::hasAge', age != '', age]);


            if (saveTheData) {
                debugLog(['setCookieData::saveTheData', saveTheData]);
                var cookieData = {
                    'age': age,
                    'healthRateCode': healthRateCode,
                    'rebateTier': $scope.model.income,
                    'asAtDateApril': $scope.model.asAtDateApril,
                    'frequency': $scope.quotePanel.value.frequency,
                    'extended': $scope.model.extended,
                    'displayPrice': $scope.quotePanel.value.price,
                    'displayPaymentFrequency': $scope.quotePanel.text.frequency,
                    'displayHospitalCover': $scope.quotePanel.text.hospitalCover,
                    'displayHospitalTierName': $scope.quotePanel.text.hospitalTierName,
                    'displayExtrasCover': $scope.quotePanel.text.extrasCover,
                    'displayRebatePercentage': $scope.quoteData.rebatePercentage,
                    'displayLHCPercentage': $scope.quoteData.lifetimeHealthCoverPercentage,
                    'displayExcess': $scope.quotePanel.value.excess,
                    'displayCoverType': getDropdownLabel($scope.quotePanel.dropdowns.coverTypes, $scope.model.coverType),
                    'displayState': getDropdownLabel($scope.quotePanel.dropdowns.state, $scope.model.state),

                };
                Cookies.set('thf-live-quote-tool', cookieData, { expires: 7 });
                if (!THF.Interface.QuotePanel.initialised) {
                    new THF.Interface.QuotePanel();
                }
            }
        }

        /**
         * Update the quote panel information when the quote data or frequency is updated.
         */
        $scope.$watchGroup(['quotePanel.value.frequency', 'quoteData'], function () {
            debugLog('$scope.watchGroup[quotePanel.value.frequency, quoteData]');

            $scope.quotePanel.show.rebateDisclaimer = true;
            $scope.quotePanel.value.rebatePercent = $scope.quoteData.rebatePercentage;

            $scope.quotePanel.show.lhcDisclaimer = true;
            $scope.quotePanel.value.lhcPercent = $scope.quoteData.lifetimeHealthCoverPercentage;

            var healthRates = _.filter($scope.quoteData.healthRates, { Frequency: $scope.quotePanel.value.frequency });
            if (healthRates.length > 0) {
                var amount = parseFloat(healthRates[0].NetAmount);
                $scope.quotePanel.value.price = amount.toFixed(2);
            }

            $timeout(function () {
                $('select').selectpicker('refresh');
            });

            setCookieData();
        });


        function setHospitalType() {
            debugLog('setHospitalType()');
            if (
                typeof $scope.selectedProduct.hospital.excessToProductCode !== 'undefined' &&
                typeof $scope.selectedProduct.hospital.excessToProductCode[$scope.quotePanel.value.excess] !== 'undefined'
            ) {
                debugLog(['setHospitalType()::excess', $scope.selectedProduct.hospital.excessToProductCode[$scope.quotePanel.value.excess]]);
                $scope.model.hospitalType = $scope.selectedProduct.hospital.excessToProductCode[$scope.quotePanel.value.excess];
            }
            else {
                $scope.model.hospitalType = $scope.selectedProduct.hospital.defaultProductCode;
                debugLog(['setHospitalType()::noexcess', $scope.selectedProduct.hospital.defaultProductCode]);
            }
        }


        /**
         * Compare Table Functionality for Mobile and Desktop.
         */
        function prepareCompareTable() {
            if (viewport.is('xs')) {
                $scope.summaryPanel.hospital.show = true;
                $scope.summaryPanel.extras.show = false;
                $scope.summaryPanel.hospital.accordionCollapsed = true;
            }
            else {
                $scope.summaryPanel.hospital.show = true;
                $scope.summaryPanel.extras.show = true;
                $scope.summaryPanel.hospital.accordionCollapsed = false;
            }
        }

        /**
         * Binds some global events that trigger certain actions
         * related to resizing of the browser.
         */
        function bindEvents() {
            debugLog('bindEvents()');

            $(window).resize(
                viewport.changed(function () {
                    debugLog('resizeEvent: original:' + originalWidth + ', new: ' + $(window).width());

                    if (originalWidth !== $(window).width()) {
                        resizeSlideWidth();
                        prepareCompareTable();
                        $scope.$apply(); // we need to call this to keep angular sane.
                    }
                }
                ));
        }

        /**
         * Resizes the slider item widths based on the container width when the browser resizes.
         */
        function resizeSlideWidth() {
            debugLog('resizeSlideWidth()');
            // Effectively only do this for mobile.
            if (viewport.is('xs')) {
                if ($scope.hospitalPanel.show) {
                    $scope.products.slideWidth = $('.live-quote-tool .hospital-panel .column.slider-container').width();
                }
                else if ($scope.extrasPanel.show) {
                    $scope.products.slideWidth = $('.live-quote-tool .extras-panel .column.slider-container').width();
                }
            }
            else {
                $scope.products.slideWidth = false;
            }
        }

        function debugLog(msg) {
            if (window.THFLogging === true) {
                if (console && console.log) {
                    console.log('[LQT]', msg);
                }
            }
        }


        debugLog('application start');

        /**
         * TODO preload the following data and only fulfil the promise when ALL the data is loaded.
         */
        PM.byType('hospital').then(function (products) {
            $scope.products.hospital = products;
        });
        PM.byType('extras').then(function (products) {
            $scope.products.extras = products;
        });
        SM.byType('hospital').then(function (serviceGroups) {
            $scope.serviceTypes.hospital = serviceGroups;
            // We need to delay until after the updates have been performed.
            $timeout(function () {
                modal.setEvents();
            });
        });
        SM.byType('extras').then(function (serviceGroups) {
            $scope.serviceTypes.extras = serviceGroups;
            // We need to delay until after the updates have been performed.
            $timeout(function () {
                modal.setEvents();
            });
        });


        selectDisplayPage();
        $scope.updateCoverTypeDisplayValue();
        showHideCheckboxes();
        bindEvents();
        prepareCompareTable();
    }]);
})(angular, _, jQuery, ResponsiveBootstrapToolkit, Cookies, window);

